import { render, staticRenderFns } from "./AdminServices.vue?vue&type=template&id=5abc06b4&"
import script from "./AdminServices.vue?vue&type=script&lang=js&"
export * from "./AdminServices.vue?vue&type=script&lang=js&"
import style0 from "./AdminServices.vue?vue&type=style&index=0&id=5abc06b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports